export const SUBMIT_BUTTON_TRIGGER_ID = 'submit-button';
export const DIALOG_BACKGROUND_TRIGGER_ID = 'dialog-background';
